(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selector = '[data-hs-reveal], product-card, .collection-card, .hs-dept, .hs-edit-card';
  let observer;

  const getObserver = () => {
    if (observer || reduced || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    return observer;
  };

  const siblingIndex = (el) => {
    const item = el.closest('.product-grid__item, .resource-list__item') || el;
    const parent = item.parentElement;
    if (!parent) return 0;
    const peers = [...parent.children].filter((node) =>
      node.matches?.('.product-grid__item, .resource-list__item, product-card, .collection-card, .hs-dept, .hs-edit-card')
    );
    return Math.max(0, peers.indexOf(item));
  };

  const prepare = (root = document) => {
    const nodes = [];
    if (root instanceof Element && root.matches(selector)) nodes.push(root);
    if (root.querySelectorAll) nodes.push(...root.querySelectorAll(selector));

    [...new Set(nodes)].forEach((el) => {
      if (!(el instanceof HTMLElement) || el.dataset.hsMotionReady === 'true') return;
      el.dataset.hsMotionReady = 'true';

      if (!el.hasAttribute('data-hs-reveal')) el.classList.add('hs-auto-reveal');

      if (el.matches('product-card, .collection-card, .hs-dept, .hs-edit-card')) {
        el.style.setProperty('--hs-reveal-delay', `${(siblingIndex(el) % 4) * 55}ms`);
      }

      if (reduced || !('IntersectionObserver' in window)) {
        el.classList.add('is-visible');
      } else {
        getObserver()?.observe(el);
      }
    });
  };

  const init = () => {
    prepare(document);

    const main = document.querySelector('#MainContent');
    if (!main || main.dataset.hsMotionObserver === 'true') return;
    main.dataset.hsMotionObserver = 'true';

    const mutations = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element) prepare(node);
        }
      }
    });

    mutations.observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();